module.exports = __webpack_public_path__ + "img/logo.cd5422fd.png";